(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2778],{

/***/ 26847:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/builder",
      function () {
        return __webpack_require__(34869);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ EmptyLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5441);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26021);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    ",
        "\n    text-align: center;\n    min-height: calc(100vh - 300px);\n\n    * > :not(h1, h2, h3, h4, h5, h6) * {\n        font-size: ",
        ";\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    filter: grayscale(1);\n    opacity: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var EmptyContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-64ebc6d8-0"
})(_templateObject(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* .CenterCenter */ .IV, function(props) {
    return props.fontSize;
});
var Img = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((next_image__WEBPACK_IMPORTED_MODULE_2___default())).withConfig({
    componentId: "sc-64ebc6d8-1"
})(_templateObject1(), function(props) {
    return props.opacity;
});
var emptyLayers = "Once dropped, you can view the layers here.";
var EmptyLayout = function(param) {
    var _width = param.width, width = _width === void 0 ? "275px" : _width, _height = param.height, height = _height === void 0 ? "150px" : _height, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "12px" : _fontSize, _opacity = param.opacity, opacity = _opacity === void 0 ? 0.3 : _opacity, _help = param.help, help = _help === void 0 ? emptyLayers : _help, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EmptyContainer, {
                fontSize: fontSize,
                children: children ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        "Drop your first item in the canvas. ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                        help
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Img, {
                width: width,
                height: height,
                opacity: opacity,
                alt: "empty canvas",
                src: "/floor-empty.jpeg"
            })
        ]
    });
};


/***/ }),

/***/ 86376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ Preview; },
/* harmony export */   "V": function() { return /* binding */ usePreviewSwitch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64485);
/* harmony import */ var _mosanic_components_Empty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80587);
/* harmony import */ var _mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8927);
/* harmony import */ var _mosanic_hooks_Breakpoint__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56542);
/* harmony import */ var _redux_map_data__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94718);
/* harmony import */ var _redux_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78726);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64157);
/* harmony import */ var _Page_Render__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26381);
/* harmony import */ var _mosanic_items_Util__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(33402);
/* harmony import */ var _redux_options_action__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(30850);
/* harmony import */ var _redux_options_reducer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51331);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26021);
/* harmony import */ var _radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77298);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2921);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    transition: margin ease-in-out 0.5s, opacity ease-in 0.3s;\n    opacity: 0;\n    bottom: -20px;\n    font-size: 12px;\n    color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    position: fixed;\n    bottom: 15px;\n    right: 25px;\n    z-index: 9999;\n    background: rgba(255, 255, 255, 0.5);  \n    padding: 10px;\n    border-radius: 10px;\n    box-shadow: 5px 5px 10px 0 rgba(0,0,0,0.2);\n    backdrop-filter: blur(10px) invert(1);\n    cursor: pointer;\n    transition: all ease-in-out 0.3s;\n    height: 45px;\n    transform: translateZ(0);\n    -webkit-font-smoothing: subpixel-antialiased;\n\n    :hover {\n        transform: scale(1.05) translateZ(0);\n        backdrop-filter: none;\n        background: #fff;\n        height: 60px;\n        \n        ",
        " {\n            opacity: 1;\n            bottom: 0px;\n        }\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var Close = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5b81bcb7-0"
})(_templateObject(), _mosanic_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"].util.gray.base */ .ZP.util.gray.base);
var Float = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5b81bcb7-1"
})(_templateObject1(), Close);
var Preview = function(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var map = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_map__WEBPACK_IMPORTED_MODULE_7__/* .mapSelector */ .Od);
    var data = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_map_data__WEBPACK_IMPORTED_MODULE_8__/* .dataSelector */ .Fb);
    var width = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_9__/* .useWindowSize */ .i)().width;
    var bp = (0,_mosanic_hooks_Breakpoint__WEBPACK_IMPORTED_MODULE_10__/* .useBreakpoint */ .G)({});
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(usePreviewSwitch(), 3), previewState = ref[0], togglePreview = ref[1], PreviewSwitch = ref[2];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        style: {
            background: "#fff",
            zIndex: 99,
            height: "calc(100vh - 40px)",
            top: "40px",
            position: "absolute"
        },
        children: (map === null || map === void 0 ? void 0 : map.length) <= 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_components_Empty__WEBPACK_IMPORTED_MODULE_12__/* .EmptyLayout */ .T, {
            fontSize: "18px",
            width: width,
            opacity: 0.15,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                        children: "Drop your first item in the canvas."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                        children: [
                            "Once you've build up your layout, ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                            "Return to the preview."
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Page_Render__WEBPACK_IMPORTED_MODULE_13__/* .RenderHeaderFooter */ .VD, {
            bp: bp,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Float, {
                    onClick: togglePreview,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PreviewSwitch, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Close, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_radix_ui_react_icons__WEBPACK_IMPORTED_MODULE_3__/* .CrossCircledIcon */ .xrR, {}),
                                " Close preview"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_components_Pages__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                    page: {
                        data: data,
                        map: map
                    },
                    mode: "prod",
                    level: 0
                })
            ]
        })
    });
};
var usePreviewSwitch = function() {
    var previewState = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_options_reducer__WEBPACK_IMPORTED_MODULE_15__/* .isPreviewCanvasSelector */ .CN);
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var togglePreview = function() {
        return dispatch((0,_redux_options_action__WEBPACK_IMPORTED_MODULE_16__/* .updatePref */ .Mc)({
            group: "builder",
            pref: "previewMode"
        }));
    };
    var Switch = function(param) {
        var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mosanic_items_Util__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    active: previewState,
                    color: previewState ? "green" : "gray"
                }),
                " Preview mode"
            ]
        });
    };
    return [
        previewState,
        togglePreview,
        Switch
    ];
};


/***/ }),

/***/ 33402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2921);
/* harmony import */ var _mosanic_styles_animations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37971);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26021);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78545);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ::before,\n        ::after {\n            content: '';\n            display: block;\n            top: calc(50% - 4px);\n            height: 8px;\n            width: 8px;\n        }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        ",
        "\n        ::before {\n            animation: status 1.8s ease-out infinite;\n        }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        ::before,\n        ::after {\n            left: -10px; \n        }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n        padding: 0 5px;\n        ::before,\n        ::after {\n            left: 0px; \n        }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        " \n    position: relative;\n    \n    ::before,\n    ::after {\n        content: '';\n        display: block;\n        top: calc(50% - 2.5px);\n        height: 5px;\n        width: 5px;\n        border-radius: 50%;\n        position: absolute;\n        background: ",
        ";\n    }\n    ",
        "\n    \n    ",
        "\n\n    ",
        "\n    ",
        "\n    ",
        "\n\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var Dot = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-463adb04-0"
})(_templateObject4(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.active) ? _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].util.bright */ .ZP.util.bright[props === null || props === void 0 ? void 0 : props.color] : props.forceColor ? _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].util.bright */ .ZP.util.bright[props === null || props === void 0 ? void 0 : props.color] : _mosanic_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"].util.gray.base */ .ZP.util.gray.base;
}, function(props) {
    return props.size === "large" && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject());
}, function(props) {
    return (props.selected || props.active) && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _mosanic_styles_animations__WEBPACK_IMPORTED_MODULE_5__/* .statusAttention */ .az);
}, function(props) {
    return props.compact ? (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3());
}, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_2__/* .space */ .Dh);
var StatusDot = function(_param) /*#__PURE__*/ {
    var active = _param.active, _compact = _param.compact, compact = _compact === void 0 ? false : _compact, _color = _param.color, color = _color === void 0 ? "primary" : _color, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "active",
        "compact",
        "color"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Dot, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        active: active,
        compact: compact,
        color: color
    }, other));
};
/* harmony default export */ __webpack_exports__["Z"] = (StatusDot);


/***/ }),

/***/ 34869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ builder; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(68875);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/jsx/ConditionalWrapper.js
var ConditionalWrapper = __webpack_require__(96344);
// EXTERNAL MODULE: ./src/features/auth/reducer.js
var reducer = __webpack_require__(25157);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(64157);
;// CONCATENATED MODULE: ./src/mosanic/auth/RedirectAuth.js




var RedirectAuth = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref;
    var router = (0,next_router.useRouter)();
    var auth = (0,es/* useSelector */.v9)(reducer/* authSelector */.aF);
    if (true) {
        var hostname = window.location.hostname;
    }
    if ((auth === null || auth === void 0 ? void 0 : (ref = auth.userData) === null || ref === void 0 ? void 0 : ref._id) && !(auth === null || auth === void 0 ? void 0 : auth.isAuth) && // process.browser && 
    (router === null || router === void 0 ? void 0 : router.asPath) != "/register" && (router === null || router === void 0 ? void 0 : router.asPath) != "/login" && "object" !== "undefined") {
        // router.push('/login');
        alert("DEBUG: redirect auth");
    // console.log(router)
    }
    return null;
};

// EXTERNAL MODULE: ./src/mosanic/cms/Query/byId.js
var byId = __webpack_require__(62357);
// EXTERNAL MODULE: ./src/mosanic/core/Provider/PageProviders.js
var PageProviders = __webpack_require__(43970);
// EXTERNAL MODULE: ./src/mosanic/core/Screens/Preview.js
var Preview = __webpack_require__(86376);
// EXTERNAL MODULE: ./src/mosanic/core/Typography/RenderFontSources.js
var RenderFontSources = __webpack_require__(13404);
// EXTERNAL MODULE: ./src/features/options/reducer.js + 1 modules
var options_reducer = __webpack_require__(51331);
// EXTERNAL MODULE: ./src/features/pages/reducer.js
var pages_reducer = __webpack_require__(80762);
// EXTERNAL MODULE: ./src/features/screens/action.js
var action = __webpack_require__(21398);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/ButtonGroup.js + 2 modules
var ButtonGroup = __webpack_require__(87567);
// EXTERNAL MODULE: ./src/mosanic/fields/Button/Buttons.js + 1 modules
var Buttons = __webpack_require__(47914);
// EXTERNAL MODULE: ./src/mosanic/Icons/ScreenIcons.js
var ScreenIcons = __webpack_require__(4956);
// EXTERNAL MODULE: ./src/features/options/action.js
var options_action = __webpack_require__(30850);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(26021);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.js
var useWindowSize = __webpack_require__(64485);
;// CONCATENATED MODULE: ./src/components/Builder/Canvas/CanvasControls.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " \n  position: absolute;\n  left: 20px;\n  bottom: 20px;\n  z-index: 99;\n  width: 200px;\n  height: 45px;\n  background: rgba(255,255,255,0.8);\n  backdrop-filter: blur(3px);\n  display: none;\n\n  @media (max-width: 600px) {\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var Controls = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-355b39ef-0"
})(_templateObject());
var CanvasControls = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var moveCanvas = (0,es/* useSelector */.v9)(options_reducer/* canMoveCanvasSelector */.wg);
    var dragDrop = (0,es/* useSelector */.v9)(options_reducer/* canDragDropSelector */.QE);
    var props = {
        moveCanvas: moveCanvas,
        dragDrop: dragDrop,
        width: width
    };
    return width < 600 || !dragDrop || !moveCanvas ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlsItem, (0,_object_spread/* default */.Z)({}, props)) : null;
};
var ControlsItem = function(param) {
    var width = param.width, dragDrop = param.dragDrop, moveCanvas = param.moveCanvas;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)("Canvas"), active = ref[0], setActive = ref[1];
    var options = [
        {
            icon: ScreenIcons/* moveHandleIcon */.lY,
            value: "Canvas"
        },
        {
            icon: ScreenIcons/* dragHandleIcon */.DO,
            value: "Drag"
        },
        {
            icon: ScreenIcons/* doubleArrowUpIcon */.WQ,
            value: "Click"
        }
    ];
    var setDragDrop = (0,react.useCallback)(function(state) {
        return dispatch((0,options_action/* updateDragDropState */.NA)(state));
    }, [
        dispatch
    ]);
    var setMoveCanvas = (0,react.useCallback)(function(state) {
        return dispatch((0,options_action/* updatePref */.Mc)({
            group: "builder",
            pref: "moveCanvas"
        }, state));
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        if (width < 600) {
            if (moveCanvas && active != "Canvas") setMoveCanvas(false);
            if (!moveCanvas && active === "Canvas") setMoveCanvas(true);
            if (dragDrop && active != "Drag") setDragDrop(false);
            if (!dragDrop && active === "Drag") setDragDrop(true);
        } else {}
    }, [
        active,
        dragDrop,
        dispatch,
        width,
        setMoveCanvas,
        setDragDrop,
        moveCanvas
    ]);
    (0,react.useEffect)(function() {
        if (width > 600) {
            if (!moveCanvas) setMoveCanvas(true);
            if (!dragDrop) setDragDrop(true);
        }
    }, [
        dragDrop,
        moveCanvas,
        setDragDrop,
        setMoveCanvas,
        width
    ]);
    if (width > 600) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Controls, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* ButtonGroup */.h, {
            height: "45px",
            children: options.map(function(option) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons.Button, {
                    active: option.value === active,
                    onClick: function() {
                        return setActive(option.value);
                    },
                    icon: option.icon,
                    label: option.value,
                    double: true,
                    size: "large"
                }, option.value);
            })
        })
    });
};
/* harmony default export */ var Canvas_CanvasControls = (CanvasControls);

;// CONCATENATED MODULE: ./src/pages/app/builder/index.js
















var BuilderWrapper = dynamic_default()(function() {
    return Promise.all(/* import() | BuilderWrapper */[__webpack_require__.e(8506), __webpack_require__.e(4675)]).then(__webpack_require__.bind(__webpack_require__, 88817));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88817)
            ];
        }
    },
    ssr: false
});
var Tour = dynamic_default()(function() {
    return Promise.all(/* import() | Builder Tour */[__webpack_require__.e(8722), __webpack_require__.e(2460), __webpack_require__.e(8417)]).then(__webpack_require__.bind(__webpack_require__, 10153));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10153)
            ];
        }
    },
    ssr: false
});
var KeyListeners = dynamic_default()(function() {
    return Promise.all(/* import() | Builder Tour */[__webpack_require__.e(8722), __webpack_require__.e(2460), __webpack_require__.e(8417)]).then(__webpack_require__.bind(__webpack_require__, 25914));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25914)
            ];
        }
    },
    ssr: false
});


var fiveMin = 300000;
var Builder = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var dispatch = (0,es/* useDispatch */.I0)();
    var siteId = (0,es/* useSelector */.v9)(reducer/* siteIdSelector */.uL);
    var ref = (0,_sliced_to_array/* default */.Z)((0,byId/* useGetSite */.iu)({
        _id: siteId
    }), 1), site = ref[0];
    var ref1 = site || {
        nav: null,
        locales: null
    }, nav = ref1.nav, locales = ref1.locales;
    var type = (0,es/* useSelector */.v9)(function(state) {
        return (0,pages_reducer/* pageMetaAttrSelector */.vz)(state, "type");
    });
    var autoSave = (0,es/* useSelector */.v9)(options_reducer/* getAutoSavePref */.ui);
    var previewCanvas = (0,es/* useSelector */.v9)(options_reducer/* isPreviewCanvasSelector */.CN);
    (0,react.useEffect)(function() {
        dispatch((0,action/* initializeScreens */.CV)());
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        var interval = null;
        if (autoSave) {
            interval = setInterval(function() {
            // alert('save')
            }, fiveMin);
        }
        return function() {
            return clearInterval(interval);
        };
    }, []);
    // useEffect(() => {
    //   router.replace({
    //       pathname: replacePart(router.pathname, '/app', ''),
    //       query: previewCanvas ? {
    //           page: current 
    //       } : null
    //   }, undefined, {shallow: true})
    // },[current, previewCanvas, router])
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* ConditionalWrapper */.M, {
        when: type === "header",
        wrapper: function(children) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageProviders/* HeaderProvider */.I7, {
                nav: nav,
                locales: locales,
                children: children
            });
        },
        children: previewCanvas ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview/* Preview */.M, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RedirectAuth, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderWrapper, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Canvas_CanvasControls, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderFontSources/* FontSources */.$0, {
                    dynamic: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyListeners, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tour, {})
            ]
        })
    });
};
/* harmony default export */ var builder = (/*#__PURE__*/(0,react.memo)(Builder));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(26847); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);